<div class="max-w-full">
    <div *ngIf="!folderSelected">
        <H3 class="text-center"><i class="fas fa-folder-closed"></i> Select A Folder</H3>
    </div>
    <div *ngIf="folderSelected">
        <app-folder-sub-list></app-folder-sub-list>
        <div class="pt-5">
            <H3 class="text-center"><i class="fas fa-folder-open"></i> No Documents in Folder</H3>
            <div class="text-center">
                <p>The Selected Folder does not contain any documents. Perhaps the documents are in a sub-folder.</p>
            </div>
        </div>
    </div>
</div>